import { useEffect, useState } from 'react';
import { getAllCategories } from '../../services/server-api';
export function useCategories() {
    var _a = useState(), categories = _a[0], setCategories = _a[1];
    useEffect(function () {
        getAllCategories().then(setCategories);
    }, []);
    return categories;
}
